import type { QuoteListRow } from "~/features/orders/quoteList/useQuoteListState";
import type { AddToCartApiItem } from "~/features/cart/cart/api/AddToCart";
import { toMoxyDate } from "~/common/types/MoxyDate";
import { isPackageRestrictionEnabled } from "~/features/PackageRestriction/utils/isPackageRestrictionEnabled";
import type { QuoteLineMO } from "~/features/orders/common/components/v2/models";

const SELECTABLE_ORDER_STATUSES: string[] = ["Q5", "Q6"];

export function canQuoteListRowBeSelected(quote: QuoteListRow): boolean {
  if (quote.errorLoadingDetails) {
    return false;
  }
  if (quote.detailsLoaded) {
    return !quote.details?.disabled;
  }

  return SELECTABLE_ORDER_STATUSES.includes(quote.data.orderStatusCode);
}

export function makeMapQuoteLineToATCAPIItem(): (line: QuoteLineMO) => AddToCartApiItem[] {
  const now = new Date();
  return (line: QuoteLineMO) => {
    const firstPart = line.parts[0];
    const quoteLine = [line.lineNo, line.parts.length > 0 && firstPart.lineNo].filter(Boolean).join(":");

    return [
      {
        productCode: line.product.code,
        packageSize: line.packSize,
        packageCode: line.packCode,
        quantity: firstPart.requestedQuantity,
        confirmedQuantity: firstPart.confirmedQuantity,
        quoteLine,
        selectedDeliveryDate: toMoxyDate(firstPart.requestedDeliveryDate ?? now),
        selectedDeliveryDateIsManual: true,
        priceReference: line.priceReference,
        isRestrictedPackage: isPackageRestrictionEnabled(),
        originCountry: "", // TODO: Provide origin country for quotes
      },
    ];
  };
}
